import styled from 'styled-components';
import { CaptionRegularM } from '../../styles/globals';
import { IThemeProvider, ITheme } from '../../styles/theme';

interface IResultLegendBar {
  theme: ITheme;
  isExpanded?: boolean;
  noBorder?: boolean;
  leftPosition?: string;
  isSimple?: boolean;
}

interface LegendSideProps {
  hideExpand?: boolean;
}

export const ResultLegendBar = styled(CaptionRegularM)<IResultLegendBar>`
  display: flex;
  align-items: baseline;
  flex-direction: column;
  font-size: 14px;
  line-height: 18px;
  ${({ theme, noBorder, leftPosition }: IResultLegendBar) => `
    margin: 0 0 ${theme.layout.spacing.centy} 0; 
   flex-wrap: wrap;
    margin: 0 0 ${noBorder ? '0' : theme.layout.spacing.centy} 0; 
    color: ${theme.colors.neutral.primary[80]};
    border-bottom: 1px solid ${theme.colors.neutral.primary[30]};
    border: solid ${theme.colors.neutral.primary[30]};
    border-width: ${noBorder ? '0' : '1px 0 1px 0'};

    ${leftPosition ? `padding: 0 ${theme.layout.spacing.centy} 0 ${leftPosition};` : 'padding: 0;'}
  `}
`;

export const LegendText = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1;
  text-align: justify;
  ${({ theme }: IThemeProvider) => `
    padding: ${theme.layout.spacing.centy} ${theme.layout.spacing.centy} 0 0;
  `}
`;

export const LegendTextCustom = styled.div<IResultLegendBar>`
  font-size: 13px;
  line-height: 16px;
  max-height: 7.75rem;
  overflow: hidden;
  font-size: 14px;
  line-height: 18px;
  text-overflow: ellipsis;
  -webkit-line-clamp: 7;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  ${({ theme, isExpanded, isSimple }: IResultLegendBar) => `
    padding: ${theme.layout.spacing.centy} ${theme.layout.spacing.centy} 0 0;
    ${isExpanded ? 'display: flex; max-height: 100%;' : ''}
    ${isSimple ? 'margin-bottom: 16px' : ''}
  `}
`;

export const LegendSide = styled.div<LegendSideProps>`
  font-size: 13px;
  line-height: 16px;
  display: flex;
  position: relative;

  ${({ hideExpand }) => `
    padding-top: ${hideExpand ? '24px' : '0'};
    padding-bottom: ${hideExpand ? '24px' : '0'};
  `}
`;

interface LegendContProps {
  theme: IThemeProvider;
  variant: string;
}

export const LegendCont = styled.div<LegendContProps>`
  display: flex;
  flex-direction: row;
  align-items: baseline;
  justify-content: space-between;
  width: 100%;
  ${({ theme, variant }) => `
    padding: ${theme.layout.spacing.mili} 0 ${theme.layout.spacing.mili};
    flex-direction: ${variant === 'rotated' ? 'column' : 'row'};
  `}
`;

export const LegendColorsMeaningCont = styled.div`
  display: flex;
  align-items: center;
  margin: 4px 0 0 0;
`;

export const BenchmarksWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const LegendColorsMeaningContRotated = styled.div`
  display: flex;
  align-items: center;
  margin: 1rem 0 0.5rem 0;
  gap: 8px;
`;

export const LinkCont = styled.div`
  display: flex;
  position: relative;
`;

export const LegendScoreBarCont = styled.span`
  ${({ theme }: IThemeProvider) => `
    margin: 0 ${theme.layout.spacing.mikro} 0 ${theme.layout.spacing.centy};
  `}
`;
export const LegendScoreBarContRotated = styled.span`
  ${({ theme }: IThemeProvider) => `
    margin: 0 ${theme.layout.spacing.mikro} 0 0;
  `}
`;

export const FlexCont = styled.div`
  display: flex;
  position: relative;
`;
